/** Academy teams at U13 or younger should not collect player contact details. */
export function parseAgeGroupYears(ageGroup) {
    const match = String(ageGroup || '').match(/U(\d+)/i);
    return match ? parseInt(match[1], 10) : null;
}

/** Youth sides add children: academy type, or any team with U18 or younger. */
export function isYouthTeam(
    teamType = sessionStorage.getItem('selected_team_type'),
    ageGroup = sessionStorage.getItem('selected_team_age_group')
) {
    if (teamType === 'academy') return true;
    const age = parseAgeGroupYears(ageGroup);
    return age !== null && age <= 18;
}

export function isAcademyU13OrYounger() {
    const selectedTeamType = sessionStorage.getItem('selected_team_type');
    const ageGroup = sessionStorage.getItem('selected_team_age_group');

    if (!isYouthTeam(selectedTeamType, ageGroup) || !ageGroup) {
        return false;
    }

    const age = parseAgeGroupYears(ageGroup);
    return age !== null && age <= 13;
}

export const fetchMatchPlayers = async (matchId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/get_attendance.php?match_id=${matchId}`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        console.log('API Response:', result);
        
        if (result.success) {
            if (!Array.isArray(result.players)) {
                console.error('Players data is not an array:', result.players);
                return { allPlayers: [], whiteTeam: [], colourTeam: [] };
            }
            return {
                allPlayers: result.players,
                whiteTeam: result.players.filter(player => player.team?.toLowerCase() === 'white'),
                colourTeam: result.players.filter(player => player.team?.toLowerCase() === 'colour')
            };
        } else {
            console.error('Failed to fetch players:', result.error);
            return { allPlayers: [], whiteTeam: [], colourTeam: [] };
        }
    } catch (error) {
        console.error('Error fetching players:', error);
        return { allPlayers: [], whiteTeam: [], colourTeam: [] };
    }
}; 